import * as t from "io-ts";
import { nullable } from "./index";
const createCargoReportTypes = ({ dateTime, }) => {
    const cargosReportRowT = t.type({
        stopId: t.string,
        arrivalDate: nullable(dateTime),
        departureDate: nullable(dateTime),
        date: nullable(dateTime),
        note: t.string,
        weight: t.string,
        cubicMeters: t.string,
        address: t.string,
        truckId: t.string,
        clientId: t.string,
        driverId: t.string,
        showCargoRelated: t.boolean,
        cargoId: t.string,
        cargoRef: t.string,
        invoiced: t.boolean,
        invoiceRef: nullable(t.string),
        position: nullable(t.strict({
            lon: t.number,
            lat: t.number,
        })),
    });
    const cargosReportTableDataT = t.array(cargosReportRowT);
    return {
        cargosReportRowT,
        cargosReportTableDataT,
    };
};
export { createCargoReportTypes };
//# sourceMappingURL=cargos-report.js.map